import * as yup from "yup";

// Esquema de validación para registrar un alumno
const registrarAlumnoSchema = yup.object().shape({
  nombre: yup
    .string()
    .required("El nombre es requerido")
    .max(50, "Maximo 50 caracteres"),
  email: yup
    .string()
    .required("El correo es requerido")
    .max(50, "Maximo 50 caracteres"),
  password: yup
    .string()
    .min(6, "La contraseña debe tener al menos 6 caracteres")
    .required("La contraseña es requerida"),
  telefono: yup
    .string()
    .required("El teléfono es requerido")
    .max(16, "Maximo 16 caracteres"),
});

// Esquema de validación para modificar clase a la venta
const modificarClaseSchema = yup.object().shape({
  cupos: yup
    .string()
    .matches(/^[0-9]*$/, "Los cupos deben ser un número")
    .nullable()
    .max(4, "Maximo 4 caracteres"),
  titulo: yup.string().required("El título es requerido"),
  descripcion: yup.string().required("La descripción es requerida"),
  precio: yup
    .string()
    .matches(
      /^[0-9]*,?[0-9]*$/,
      "El precio debe ser un número que puede contener comas"
    )
    .max(10, "Maximo 10 caracteres"),
  moneda: yup
    .string()
    .max(8, "La moneda puede tener hasta 8 caracteres alfanuméricos"),
  link_binance: yup
    .string()
    .url("El link de Binance debe ser una URL válida")
    .optional(),
  link_mp: yup
    .string()
    .url("El link de Mercado Pago debe ser una URL válida")
    .optional(),
  link_hotmart: yup
    .string()
    .url("El link de débito / hotmart debe ser una URL válida")
    .optional(),
});

// Esquema de validación para agregar contenido de clase
const agregarContenidoSchema = yup.object().shape({
  titulo: yup.string().required("El título es requerido"),
  descripcion: yup.string().required("La descripción es requerida"),
  link: yup
    .string()
    .url(
      "El link debe ser una URL válida (asegurate de incluir http:// o https://)"
    )
    .required("El link es requerido"),
  fecha: yup.date(),
  alumno: yup.string().optional(),
});

export { registrarAlumnoSchema, modificarClaseSchema, agregarContenidoSchema };
